import { GET_FAMILIA,
  GET_FAMILIAS,
  GET_FAMILIAS_ALL,
  GET_FAMILIAS_COUNT,
  ADD_FAMILIA,
  DELETE_FAMILIA,
  UPDATE_FAMILIA } from "../action"

// ** Initial State
const initialState = {
  data: [],
  allData: [],
  selectedProducto: {},
  gruposAtributos: [],
  atributos: [],
  categorias: [],
  familias: [],
  empresas: [],
  selectedEmpresaId: 1,
  params: {},
  processing: false
}

const prefix = 'familias'

const familias = (state = initialState, action) => {
  switch (action.type) {
    case `${prefix}/GET_ALL_DATA`:
      return { ...state, allData: action.data }
      case GET_FAMILIAS:
      return {
        ...state,
        data: action.familias,
        total: action.total || 0,
        processing: false
      }
      case GET_FAMILIAS_ALL:
      return {
          ...state,
          familias: action.familias,
          processing: false
      }
     case GET_FAMILIA:
       return { ...state, selectedFamilia: action.selectedFamilia }
    case ADD_FAMILIA:
      return { ...state, data: state.data.concat(action.data) }
    case DELETE_FAMILIA:
      return { ...state, data: [...state.data].filter(familia => familia.id !== action.data)}
    case GET_FAMILIAS_COUNT:
      return { ...state, total: action.total }
    case UPDATE_FAMILIA:
      return { ...state, data: state.data.map(familia => (familia.id === action.data.id ? action.data : familia)) }
    default:
      return { ...state }
  }
}
export default familias
